import { TypeCompiler } from '@sinclair/typebox/compiler';

import { DailySchedule } from '../schema/daily-schedule.schema';

export const DailyScheduleValidator = TypeCompiler.Compile(DailySchedule);
